define([
    "dojo/_base/declare",
    "dijit/registry",
    "dijit/focus",
    "dojo/_base/lang",
    "dojo/on",
    "dojo/keys"
], function (declare, registry, focusUtil, lang, on, keys) {

    return declare(null, {

        postCreate: function () {
            this.inherited(arguments);
            this.own(on(this, "keydown", lang.hitch(this, "_handleKeyBoardNavigation")));
        },

        _handleKeyBoardNavigation: function (event) {
            // var currentFocusedElement = document.activeElement;
            var currentFocusedElement = focusUtil.curNode;
            if (event.keyCode === keys.DOWN_ARROW) {
                this._handleDownArrow(currentFocusedElement);
                event.preventDefault();
            } else if (event.keyCode === keys.UP_ARROW) {
                this._handleUpArrow(currentFocusedElement);
                event.preventDefault();
            } else if (event.keyCode === keys.PAGE_UP || event.keyCode === keys.HOME) {
                this._moveToFirstChild(currentFocusedElement);
                event.preventDefault();
            } else if (event.keyCode === keys.PAGE_DOWN || event.keyCode === keys.END) {
                this._moveToLastChild(currentFocusedElement);
                event.preventDefault();
            }
        },
        _handleDownArrow: function (domNode) {

            var nextNode;
            if (domNode.parentElement.lastChild === domNode) {
                nextNode = domNode.parentElement.firstChild;
                //If last child is not focusable, find next focusable
                nextNode = this._moveToNextFocusableNode(nextNode);
            }
            else {
                //Check for non key board navigable nodes: Skip separators, MenuPanel and Headers
                nextNode = domNode.nextSibling;
                nextNode = this._moveToNextFocusableNode(nextNode);
            }
            nextNode.focus();

        },
        _handleUpArrow: function (domNode) {
            var prevNode;
            if (domNode.parentElement.firstChild === domNode) {
                prevNode = domNode.parentElement.lastChild;
                //If first child is  not focusable, find next focusable
                prevNode = this._moveToPreviousFocusableNode(prevNode);
            }

            else {
                //Check for non key board navigable nodes: Skip separators, MenuPanel and Headers
                prevNode = domNode.previousSibling;
                prevNode = this._moveToPreviousFocusableNode(prevNode);
            }
            prevNode.focus();
        },

        _moveToNextFocusableNode: function (node) {
            var widget;
            while (node) {
                widget = registry.getEnclosingWidget(node);
                if (node.getAttribute("data-refuse-key-nav") || widget && widget.get("disabled") || node.style.display ==="none") {
                    //For last Item next sibling will be null
                    //If there is a sibling it accepts focus
                    if (node.nextSibling) {
                        node = node.nextSibling;
                    } else {
                        //If there is no sibling, we need to cycle
                        //First child may not be a node accepting focus
                        node = this._moveToFirstChild(node);
                    }

                } else {
                    break;
                }
            }
            return node;
        },

        _moveToPreviousFocusableNode: function (node) {
            var widget;
            while (node) {
                widget = registry.getEnclosingWidget(node);
                if (node.getAttribute("data-refuse-key-nav") || widget && widget.get("disabled")|| node.style.display ==="none") {
                    //For first item, previousSibling will be null
                    //If there is a sibling it accepts focus
                    if (node.previousSibling) {
                        node = node.previousSibling;
                    } else {
                        //If there is no sibling, we need to cycle
                        //Last child may not be a node accepting focus
                        node = this._moveToLastChild(node);
                    }
                } else {
                    break;
                }
            }
            return node;
        },

        _moveToFirstChild: function (node) {
            var nextNode = node.parentElement.firstChild;
            while (nextNode) {
                if (nextNode.getAttribute("data-refuse-key-nav")) {
                    nextNode = nextNode.nextSibling;
                } else {
                    break;
                }
            }
            return nextNode;
        },

        _moveToLastChild: function (node) {
            var previousNode = node.parentElement.lastChild;
            while (previousNode) {
                if (previousNode.getAttribute("data-refuse-key-nav")) {
                    previousNode = previousNode.previousSibling;
                } else {
                    break;
                }
            }
            return previousNode;
        }
    });

})
;
